export const routeRoleConfig = {
  "/": [],
  "/home": [],
  "/preferences": [],
  "/files": [],
  "/timeline": [],
  "/tools": [],
  "/download": [],
  "/upload": ["user.uploader", "user.upload", "user.admin"],
  "/search": [],
  "/preview": [],
  "/file-compare": [],
  "/users": ["user.admin"],
  "/dbcombiner": [],
  "/dbcombiner_task_status": [],
  "/dit": [],
  "/devices": [],
  "/devices/user": [],
  "/devices/admin": ["user.admin"],
};